import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchDeliverySettingEntity } from '../../domain/entities/BranchDeliverySettingEntity'
import { BranchDeliverySystemType } from '../../domain/enums/BranchDeliverySystemType'
import { UpdateBranchSegmentModel } from './UpdateBranchSegmentMode'

export class UpdateBranchDeliverySettingModel extends BranchDeliverySettingEntity {
  constructor(dataDto: BranchDeliverySettingEntity) {
    super()

    const branchSegments = dataDto.perDirectDistanceSegment?.segments?.map(
      (segment) => new UpdateBranchSegmentModel(segment)
    )
    mapEntityProperties<UpdateBranchDeliverySettingModel>(this, dataDto, {
      map: {
        perDirectDistance:
          dataDto.valueType === BranchDeliverySystemType.PER_DIRECT_DISTANCE
            ? dataDto.perDirectDistance
            : undefined,
        perDirectDistanceSegment:
          dataDto.valueType === BranchDeliverySystemType.PER_DIRECT_DISTANCE_SEGMENT
            ? {
                segments: branchSegments
              }
            : undefined
      }
    })
  }
}
